import axios from 'axios';
const httpClient = axios.create();

export const useZengaApi = (baseUrl) => {
	const getAdverts = (advertIds) => httpClient.get(`${baseUrl}/adverts/cards?filter[advertId]=${advertIds}`);
	const getLocationList = (nameFragment) => httpClient.get(`${baseUrl}/adverts/search/locations`, { params: { nameFragment } });

	return { getAdverts, getLocationList };
};
